import React, { useState } from "react";
import SearchBar from "../components/knowledgebase/SearchBar";
import Faqs from "../components/knowledgebase/Faqs";
import Article from "../components/knowledgebase/Article";

const KnowledgeBase = () => {
  const [isFaqModalOpen, setIsFaqModalOpen] = useState(false);

  return (
    <div className="flex flex-col gap-8 py-6">
      <SearchBar onAddFaq={() => setIsFaqModalOpen(true)} />
      <Article />
      <Faqs isModalOpen={isFaqModalOpen} setIsModalOpen={setIsFaqModalOpen} />
    </div>
  );
};

export default KnowledgeBase;
